import React from "react";
import { graphql, StaticQuery } from "gatsby";
import { RichText as PrismicRichText } from "prismic-reactjs";

import { H1, RichText, Box, SEO, SectionWrapper } from "src/components";

import serializer from "src/utils/serializer";
import linkResolver from "src/utils/linkResolver";

const PolicyPage = ({ preview }) => (
  <StaticQuery
    query={graphql`
      {
        prismicPrivacyPolicy {
          dataString
        }
      }
    `}
    render={data => {
      let page = JSON.parse(data.prismicPrivacyPolicy.dataString);
      if (preview) {
        page = preview;
      }
      return (
        <>
          <SEO
            image={page.seo_image && page.seo_image.url}
            title={page.seo_title && PrismicRichText.asText(page.seo_title)}
            description={
              page.seo_description &&
              PrismicRichText.asText(page.seo_description)
            }
          />
          <SectionWrapper>
            <Box maxWidth={600} mt={6}>
              <H1
                children={page.header && PrismicRichText.asText(page.header)}
                mb={4}
              />
              <RichText>
                {page.privacy_policy &&
                  PrismicRichText.render(
                    page.privacy_policy,
                    linkResolver,
                    serializer
                  )}
              </RichText>
            </Box>
          </SectionWrapper>
        </>
      );
    }}
  />
);

export default PolicyPage;
